import { jsx as t } from "react/jsx-runtime";
import { S as h } from "./chunks/index.CCavb-1K.js";
import { c as x } from "./chunks/index.rKuIKazb.js";
import f from "react";
import { useRouterMutateOnClick as C } from "./router-provider.js";
import { Flex as d } from "./flex.js";
import { Text as I } from "./text.js";
import { Icon as L } from "./icon.js";
import { u as b, A as g } from "./chunks/as-child-context.ihEwNgkv.js";
import './assets/link.css';const _ = f.forwardRef(({ icon: e }, s) => /* @__PURE__ */ t(L, { icon: e, ref: s }));
_.displayName = "Link.Icon";
const A = "_link_1op1f_3", N = "_disabled_1op1f_16", R = "_text_1op1f_19", P = "_inline_1op1f_31", n = {
  link: A,
  disabled: N,
  text: R,
  inline: P
}, p = f.forwardRef(
  ({
    variant: e = "link-100",
    linkType: s = "text",
    children: o,
    className: a,
    disabled: k,
    inline: u,
    asChild: r,
    ...i
  }, l) => {
    const { hasAsChildParent: c } = b(), m = x(
      n.link,
      n[s],
      {
        [n.disabled]: k,
        [n.inline]: u
      },
      a
    );
    return C(i), /* @__PURE__ */ t(g, { hasAsChildParent: r, children: c ? /* @__PURE__ */ t("a", { ref: l, className: a, ...i, children: o }) : /* @__PURE__ */ t(I, { variant: e, asChild: !0, children: r ? /* @__PURE__ */ t(d, { gap: 50, alignItems: "center", asChild: !0, children: /* @__PURE__ */ t(h, { className: m, ...i, children: o }) }) : /* @__PURE__ */ t(
      "a",
      {
        ref: l,
        className: c ? a : m,
        ...i,
        children: /* @__PURE__ */ t(d, { gap: 50, alignItems: "center", children: o })
      }
    ) }) });
  }
), q = Object.assign(p, { Icon: _ });
p.displayName = "Link";
export {
  q as Link
};
//# sourceMappingURL=link.js.map
